module.exports = __webpack_public_path__ + "static/media/file-creating.0002f267.gif";